import { init as initApm } from '@elastic/apm-rum';

const apm = initApm({
    serviceName: process.env.VUE_APP_APM_SERVICE_NAME,
    serverUrl: process.env.VUE_APP_APM_SERVER_URL,
    apiKey: process.env.VUE_APP_APM_API_KEY,
    environment: process.env.VUE_APP_APM_ENVIRONMENT,
    ignoreUrls: process.env.VUE_APP_APM_TRANSACTION_IGNORE_URLS
        ? process.env.VUE_APP_APM_TRANSACTION_IGNORE_URLS.split(',')
        : [],
});

export default apm;